import Vue from 'vue';

import AppButton from '@/components/ui/buttons/AppButton.vue';
import AppInputLabel from '@/components/ui/form/AppInputLabel.vue';
import AppInputField from '@/components/ui/form/AppInputField.vue';
import AppValidationInputField from '@/components/ui/form/AppValidationInputField.vue';
import AppInputGroup from '@/components/ui/form/AppInputGroup.vue';
import AppCard from '@/components/ui/general/AppCard.vue';
import Icon from '@/components/ui/general/Icon.vue';
import Container from '@/components/ui/general/Container.vue';
import Spinner from '@/components/ui/general/Spinner.vue';
import ModalWindow from '@/components/ui/general/ModalWindow.vue';
import InlineError from '@/components/ui/general/InlineError.vue';
import Errors from '@/helpers/errors';
// Modals
import EventSaveModal from '@/components/event/EventSaveModal.vue';
import EventDeleteModal from '@/components/event/EventDeleteModal.vue';
import ProfileEditModal from '@/components/profile/ProfileEditModal.vue';
import ProfileChangePasswordModal from '@/components/profile/ProfileChangePasswordModal.vue';
import '@/bootstrap/vee-validate';

Vue.prototype.$Errors = Errors;

Vue.component('mj-button', AppButton);
Vue.component('mj-input-label', AppInputLabel);
Vue.component('mj-validation-input-field', AppValidationInputField);
Vue.component('mj-input-field', AppInputField);
Vue.component('mj-input-group', AppInputGroup);
Vue.component('mj-card', AppCard);
Vue.component('mj-icon', Icon);
Vue.component('mj-container', Container);
Vue.component('mj-spinner', Spinner);
Vue.component('mj-modal-window', ModalWindow);
Vue.component('mj-inline-error', InlineError);
// Modals
Vue.component('mj-event-save-modal', EventSaveModal);
Vue.component('mj-event-delete-modal', EventDeleteModal);
Vue.component('mj-profile-edit-modal', ProfileEditModal);
Vue.component('mj-profile-change-password-modal', ProfileChangePasswordModal);
